// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PauseOutlinedSvg from "@fishx/icons-svg/es/asn/PauseOutlined";
import FishxIcon from '../components/FishxIcon';

var PauseOutlined = function PauseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PauseOutlinedSvg
  }));
};

PauseOutlined.displayName = 'PauseOutlined';
export default React.forwardRef(PauseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PauseOutlined.js
// module id = 3764
// module chunks = 0